import React from "react";
import Linkedin from "../static/img/linkedin.png";
import Email from "../static/img/email.png";


export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  render() {
    return (
      <div className="contact d-flex flex-column-reverse flex-md-row">
        <div className="contact-left ">
          <div className="d-flex flex-column m-2  ml-sm-5 m-sm-3">
            <span className="contact-txt">Contact info </span>
          </div>
          <div className="d-flex flex-column m-2 ml-sm-5 m-sm-3 ">
            <div className="d-flex flex-row align-items-center">

              <img
                src={Email}
              />  takoua.chaabane@gmail.com
                              </div>
            <a href="https://www.linkedin.com/in/takwachaabane"
              target="_blank" >
              <img
                src={Linkedin}
              /> Linkedin : Takwa Chaabane
                    </a>
          </div>
        </div>
        <div className="contact-right d-flex justify-content-center align-items-center">
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact.js